// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { LazyImagePresentationProps, LazyImageProps } from "@insite/mobius/LazyImage";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import buildMiniSplitSystems from "@plumberssupply/App/Handlers/SystemBuilder/buildMiniSplitSystems";
import buildUnitarySystems from "@plumberssupply/App/Handlers/SystemBuilder/buildUnitarySystems";
import { CustomAppState } from "@plumberssupply/App/Store/Reducers";
import LazyImage from "@plumberssupply/MobiusOverrides/LazyImage";
import { mergeWithCss } from "@plumberssupply/XDL/Utilities";
import React, { FC, useState } from "react";
import { connect, ResolveThunks, useDispatch } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    title: string;
    imageSrc: string;
    description: string;
    extendedStyles?: SystemBuilderTypeStyles;
    type: "unitary" | "miniSplit";
}

export interface SystemBuilderTypeStyles {
    wrapper?: InjectableCss;
    infoWrapper?: InjectableCss;
    title?: TypographyPresentationProps;
    description?: TypographyPresentationProps;
    button?: ButtonPresentationProps;
    imageWrapper?: InjectableCss;
    image?: LazyImageProps;
    buttonWrapper?: InjectableCss;
}

type Props = OwnProps;

export const systemBuilderTypeStyles: SystemBuilderTypeStyles = {};

const SystemBuilderType: FC<Props> = ({ extendedStyles, title, imageSrc, description, type }) => {
    const [styles] = useState(() => mergeWithCss(systemBuilderTypeStyles, extendedStyles));
    const dispatch = useDispatch();
    const handleBuildSystem = () => {
        dispatch({
            type: "xSystemBuilder/SetStep",
            step: 1,
            systemType: type,
        } as any);
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.imageWrapper}>
                <LazyImage {...styles.image} src={imageSrc} />
            </StyledWrapper>
            <StyledWrapper {...styles.infoWrapper}>
                {title && <Typography {...styles.title}>{title}</Typography>}
                {description && <Typography {...styles.description}>{description}</Typography>}
                <StyledWrapper {...styles.buttonWrapper}>
                    <Button {...styles.button} onClick={handleBuildSystem}>
                        {translate("Build System")}
                    </Button>
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default SystemBuilderType;
